import _ from 'lodash';
import { Enum, EnumType } from 'ts-jenum';

@Enum<FieldReferenceTypeEnum>('value')
export class FieldReferenceTypeEnum extends EnumType<FieldReferenceTypeEnum>() {
   static readonly GROUP = new FieldReferenceTypeEnum('GROUP', 2);

   static readonly USER = new FieldReferenceTypeEnum('USER', 3);

   static getValues(): FieldReferenceTypeEnum[] {
      return _(FieldReferenceTypeEnum.values()).value();
   }

   constructor(public value, public id) {
      super();
   }
}
